// SPDX-FileCopyrightText: Copyright 2025 Dash0 Inc.

import clsx from "clsx";
import React from "react";
import {rewriteHeadingIds} from "../utils/rewrite-heading-ids";

interface SectionWrapperProps {
  doc: {
    id: string;
    label: string;
    content?: React.ReactNode;
  };
  children?: React.ReactNode;
  withBorder?: boolean;
  className?: string;
}

export const IntegrationDocSection: React.FC<SectionWrapperProps> = ({
  doc,
  children,
  withBorder = true,
  className,
}) => {
  const contentId = `${doc.id}-content`;
  const processedContent = rewriteHeadingIds(
    doc.content ?? children,
    contentId,
  );

  return (
    <section
      className={clsx(
        "flex flex-col lg:flex-row mt-8 lg:mt-16 relative lg:gap-[30px]",
        className,
      )}
    >
      <div
        className={clsx(
          "text-2xl lg:sticky top-24 h-fit font-medium leading-xxl pt-0 col-span-full lg:col-span-3 pb-8 lg:pb-0  flex flex-col justify-between lg:min-w-[306px]",
          withBorder && "lg:border-t lg:border-grey-800 lg:pt-3",
        )}
      >
        <h2 id={doc.id} className="mt-0 mb-0 text-lg font-medium">
          {doc.label}
        </h2>
      </div>

      <div
        className="ymdxContent prose-dark [&_p]:text-grey-400 [&_p>strong]:text-white [&_li]:text-[#bdbdbd] prose prose-xs lg:max-w-[757px] col-span-full lg:col-span-8 lg:col-start-4 w-full"
        id={contentId}
      >
        {processedContent}
      </div>
    </section>
  );
};
